import * as React from 'react';

import type { IconProps } from '../../types';

/**
 * LibraryBig icon
 *
 * @category Product
 */
const LibraryBig = React.forwardRef<SVGSVGElement, IconProps>(
  ({ 'data-testid': testId, size = 20, className, ...props }, ref) => {
    return (
      <svg
        ref={ref}
        data-testid={testId}
        width={size}
        height={size}
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={className}
        role="img"
        aria-hidden="true"
        {...props}
      >
        <path
          d="M5.83333 2.5V17.5M3.33333 2.5H8.33333C8.79357 2.5 9.16667 2.8731 9.16667 3.33333V16.6667C9.16667 17.1269 8.79357 17.5 8.33333 17.5H3.33333C2.8731 17.5 2.5 17.1269 2.5 16.6667V3.33333C2.5 2.8731 2.8731 2.5 3.33333 2.5ZM17 15.75C17.1667 16.1667 16.9167 16.6667 16.5 16.8333L14.9167 17.4167C14.5 17.5833 14 17.3333 13.8333 16.9167L9.25 4.25C9.08333 3.83333 9.33333 3.33333 9.75 3.16667L11.3333 2.58333C11.75 2.41667 12.25 2.66667 12.4167 3.08333L17 15.75Z"
          stroke="currentColor"
          strokeWidth={1.5}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    );
  }
);

LibraryBig.displayName = 'LibraryBig';

export { LibraryBig };
